import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
    const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#050A1F] to-[#0B112E] text-white relative overflow-hidden">

      {/* Animated floating emojis */}
      <motion.div
        className="absolute text-6xl top-20 left-10"
        animate={{ y: [0, 20, 0], rotate: [0, 10, -10, 0] }}
        transition={{ repeat: Infinity, duration: 4 }}
      >
        🤖
      </motion.div>
      <motion.div
        className="absolute text-6xl bottom-20 right-10"
        animate={{ y: [0, -20, 0], rotate: [0, -10, 10, 0] }}
        transition={{ repeat: Infinity, duration: 5 }}
      >
        🚀
      </motion.div>

      {/* Funny 404 Text */}
      <motion.h1
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-8xl font-extrabold bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent drop-shadow-lg"
      >
        404
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
        className="mt-4 text-xl text-gray-300 text-center px-4"
      >
        Oops! The page you’re looking for has <span className="text-purple-400">teleported</span> to another galaxy 🌌
      </motion.p>

      {/* Funny button */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: "spring", stiffness: 200 }}
        className="mt-8"
      >
        <motion.button
            onClick={() => navigate("/")}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.8 }}
            className="mt-8 px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg font-semibold text-white hover:scale-105 transition-transform shadow-lg"
        >
            🏠 Back to Home
        </motion.button>
      </motion.div>

      {/* Background animation */}
      <motion.div
        className="absolute w-[600px] h-[600px] bg-purple-500/10 rounded-full blur-3xl"
        animate={{
          x: [0, 100, -100, 0],
          y: [0, 50, -50, 0],
        }}
        transition={{ repeat: Infinity, duration: 20 }}
      />
    </div>
  );
}
